import { Lookup } from "./lookup";

export class SelfDeclaration {
    name: string;
    createdOn: Date;
    assessment: Lookup;
    contact: Lookup;
}
